export const environment = {
  production: true,
  base_url: 'https://padgettagent.fingent.net/api',
  brokerRoleName: "B+E Broker",
  intercom_api: '',
  //intercom_api: 'vfdtgib4',
  share_url: 'https://be-testing-new.fingent.net',
  video_name: 'B+E_H264.mov',
  siteurl: 'https://be-testing-new.fingent.net',
  WPsiteurl: 'http://be-dev.fingent.net/',
  auth0: {
    domain: 'benetlease-dev.auth0.com',
    tenant: 'benetlease-dev',
    customdomain: 'login.tradenetlease.com',
    configurationBaseUrl: 'https://cdn.auth0.com/',
    clientId: '1Yg4WXeLNPWiQIyTV1mphKaYBn2GhuRW',
    callbackURL: 'https://be-testing-new.fingent.net',
    connection: "BEStaging",
    url: 'https://benetlease-dev.auth0.com/',
    tokenRefreshTime: 0,
    redirect: false,
    defaultPassword: "Abcd@123"
  },
  auth0API: {
    client_id: '6QwlK3RdGHUz7dpmxH78rG1wAqAxul5y',
    client_secret: 'N43-lwSxdz2EmeMSal-TvunADLaF8lztLPmp7EVx7HFhR_nJ_PiNoBHv-1CSR1id',
    grant_type: 'client_credentials',
    url: 'https://benetlease-dev.auth0.com/'
  },
  mailchimp: {
    apikey: 'demo_2fd89259e2389e0c0ead99096',
    listID: 'demo_d16603ca94',
  },
  jwtTokenExpiry: 3,
  importExcelPath: 'https://be-dev.s3.amazonaws.com/BE/ImportTemplate',
  stockNewsAPIToken: 'd9sry2skkb8zamv12vclrzsibrpkydzx2l84ulat',
  rapidapihost: 'apidojo-yahoo-finance-v1.p.rapidapi.com',
  rapidapikey: '05e6dcddd4msha967cba4b6adfeap1093d3jsn4a824503bfa1'
};
